import { fontDisplay, fontDisplayExtraBold, lineHeightToFontSize } from 'common-react';
import { createStyles, makeStyles, Theme, ThemeColorsModel, ThemeFontSizeModel } from 'ui-components';

const DESCRIPTION_SPACING = 16;
const DESCRIPTION_TRANSITION_MS = 200;

export default makeStyles((theme: Theme & {
  color: ThemeColorsModel;
  fontSize: ThemeFontSizeModel;
}) => createStyles({
  root: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px',
    },
  },

  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
  },

  stepHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  title: {
    textAlign: 'left',
    [theme.breakpoints.down('xs')]: {
      font: fontDisplayExtraBold('normal', theme.fontSize.xxl, lineHeightToFontSize.xxl),
    },
  },

  stepHeading: {
    [theme.breakpoints.down('xs')]: {
      font: fontDisplay('normal', theme.fontSize.l, lineHeightToFontSize.l),
    },
  },

  fields: {
    display: 'flex',
    flexDirection: 'column',
    gap: 32,
  },

  field: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  input: {
    width: '100%',

    '& .MuiFormControl-root, & .MuiInputBase-root': {
      width: '100%',
    },
  },

  suffixInput: {
    '& .MuiInputBase-root': {
      overflow: 'hidden',
    },
    '& .MuiInputAdornment-root': {
      position: 'relative',
      marginTop: 0,

      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: -16,
        bottom: -16,
        width: 1,
        backgroundColor: theme.color.greys[40],
      },
    },
    '& .MuiInputAdornment-positionEnd': {
      paddingLeft: 16,
      marginLeft: 16,
      marginRight: 8,

      '&:before': {
        right: '100%',
      },
    },
    '& .Mui-error .MuiInputAdornment-root:before': {
      backgroundColor: theme.color.reds[100],
    },
  },

  fieldset: {
    display: 'flex',
    flexDirection: 'column',
    border: 0,
    margin: 0,
    padding: 0,
    minInlineSize: 'auto',
  },

  legend: {
    padding: 0,
    marginBottom: 8,
  },

  fieldsetError: {
    marginTop: 8,
  },

  radioGroup: {
    gap: 16,
    flexWrap: 'wrap',
  },

  descriptionWrapper: {
    display: 'grid',
    gridTemplateRows: '1fr',
    opacity: 1,
    transition: `${DESCRIPTION_TRANSITION_MS}ms ease`,
    transitionProperty: 'grid-template-rows, opacity',

    '@media (prefers-reduced-motion: reduce)': {
      transition: 'none',
    },
  },

  descriptionWrapperHidden: {
    gridTemplateRows: '0fr',
    opacity: 0,
  },

  descriptionClip: {
    minHeight: 0,
    overflow: 'hidden',
  },

  description: {
    paddingTop: DESCRIPTION_SPACING,
  },

  labelWithTooltip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
  },

  labelTooltip: {
    display: 'inline-flex',
  },

  submitButton: {
    width: '100%',
  },
}), { name: 'RetirementCalculatorForm' });
